import axiosInstance from './axios';
import backendUrl from '../backendUrl';
import { token } from './auth';

const baseUrl = `${backendUrl}/api/users`;

const setConfig = () => {
  return {
    headers: { 'x-auth-token': token },
  };
};

const getUser = async (
  username: string,
  limit: number,
  page: number
): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/${username}/?limit=${limit}&page=${page}`
  );
  return response.data;
};

const uploadAvatar = async (avatarObj: any): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/avatar`,
    avatarObj,
    setConfig()
  );
  return response.data;
};

const removeAvatar = async (): Promise<any> => {
  const response = await axiosInstance.delete(`${baseUrl}/avatar`, setConfig());
  return response.data;
};

const updateThemePreference = async (
  themePreference: 'light' | 'dark' | 'system'
): Promise<any> => {
  const response = await axiosInstance.patch(
    `${baseUrl}/me/theme`,
    { themePreference },
    setConfig()
  );
  return response.data;
};

const updateFeedTopics = async (feedTopics: string[]): Promise<any> => {
  const response = await axiosInstance.patch(
    `${baseUrl}/me/topics`,
    { feedTopics },
    setConfig()
  );
  return response.data;
};

const getDeletionStatus = async (): Promise<any> => {
  const response = await axiosInstance.get(`${baseUrl}/me/deletion`, setConfig());
  return response.data;
};

const requestDeletion = async (password: string): Promise<any> => {
  const response = await axiosInstance.post(`${baseUrl}/me/deletion`, { password }, setConfig());
  return response.data;
};

const cancelDeletion = async (): Promise<any> => {
  const response = await axiosInstance.delete(`${baseUrl}/me/deletion`, setConfig());
  return response.data;
};

const searchUsers = async (query: string, limit = 20): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/search/?q=${encodeURIComponent(query)}&limit=${limit}`
  );
  return response.data;
};

const getUserPreview = async (username: string): Promise<any> => {
  const response = await axiosInstance.get(
    `${baseUrl}/${encodeURIComponent(username)}/preview`
  );
  return response.data;
};

/** Report accumulated active-seconds-for-today toward the daily streak. */
const recordActivity = async (activeSeconds: number): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/me/activity`,
    { activeSeconds },
    setConfig()
  );
  return response.data;
};

/** Report another user's profile to platform staff. */
const reportUser = async (username: string, reason: string, detail?: string): Promise<any> => {
  const response = await axiosInstance.post(
    `${baseUrl}/${encodeURIComponent(username)}/report`,
    { reason, detail },
    setConfig()
  );
  return response.data;
};

const userService = {
  getUser,
  getUserPreview,
  uploadAvatar,
  removeAvatar,
  updateThemePreference,
  updateFeedTopics,
  searchUsers,
  getDeletionStatus,
  requestDeletion,
  cancelDeletion,
  recordActivity,
  reportUser,
};

export default userService;
